export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '98a3f6eb-ac45-4dcd-b601-b3aaa284f8ed';
export const MODAL_CLOSE_SEC = 2.5;
